import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Button } from 'src/common/button';
import { promiseDelay } from 'src/common/helpers/promise-delay';
import { NeueJourneyLoadingSpinner } from 'src/editor/content-creation/components/loading/journey-spinner';
import { MiniModal } from 'src/editor/content-creation/components/mini-modal';
import { NeueJourneyButton } from 'src/editor/content-creation/components/neue-button/journey';
import { functionNoop } from 'src/utils/function/noop';

export const AccountDeactiveWidget = ({ 
  onAcceptClick, 
  buttonClassName 
}: { 
  onAcceptClick: () => Promise<void>;
  buttonClassName?: string;
}) => {
  const [loading, setLoading] = useState(false);
  const modalOpenRef = useRef(functionNoop);
  const modalCloseRef = useRef(functionNoop);

  const onDeactivateAccountClicked = () => {
    modalOpenRef.current();
  };

  const onAcceptClicked = async () => {
    setLoading(true);
    try {
      await onAcceptClick();
      await promiseDelay(6_000);
      // Logout user after organization deletion
      window.location.href = '/login';
    } catch (error) {
      setLoading(false);
      modalCloseRef.current();
    }
  };

  const onDeclineClicked = () => {
    modalCloseRef.current();
  };

  return (
    <>
      <button 
        onClick={onDeactivateAccountClicked} 
        type='button' 
        className={buttonClassName || 'btn-bedrock-secondary'}
      >
        Delete organization
      </button>
      <MiniModal
        openRef={modalOpenRef}
        closeRef={modalCloseRef}
        width='430px'
        subtitle={
          <div className='flex flex-col gap-2 text-bedrock-white'>
            <h3 className='text-neue-journey-medium-strong text-inherit'>Warning: This action is permanent</h3>
            <div className='flex flex-col gap-1'>
              <span className='text-neue-journey-medium text-inherit'>
              Deleting the organization is permanent and it cannot be undone. This will delete the entire organization and all of its members. Your members will lose access to the dashboard.
              </span>
              <span className='text-neue-journey-medium  text-inherit'>
                Are you sure you want to delete organization?
              </span>
            </div>
          </div>
        }
      >
        <div className={classNames('flex gap-2', { 'pointer-events-none': loading })}>
          <NeueJourneyButton 
            type='button' 
            onClick={onAcceptClicked} 
            className='w-[50px]'
            style={{ '--neue-button-background-color': '#ef4444' } as React.CSSProperties}
          >
            {!loading ? 'Yes' : <NeueJourneyLoadingSpinner size='16' />}
          </NeueJourneyButton>
          <Button type='button' size='regular' variant='secondary' label='No' onClick={onDeclineClicked} />
        </div>
      </MiniModal>
    </>
  );
};
